import { render, staticRenderFns } from "./FactoryProductLayout.vue?vue&type=template&id=b6fbf33c&scoped=true"
import script from "./FactoryProductLayout.vue?vue&type=script&lang=js"
export * from "./FactoryProductLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6fbf33c",
  null
  
)

export default component.exports